import { type FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useQuery } from '@apollo/client';
import { Squircle, Typography } from '@shinetools/sunshine-universal';

import SunshineCard from 'components/_core/SunshineCard';
import ErrorView from 'components/ErrorView';

import { GetChallengeOriginDetailsDocument } from '../graphql/queries/getChallengeOriginDetails.gql';
import OperationDetailsItem from './OperationDetailsItem';

export interface ChallengeRequestOriginDetailsProps {
  originDeviceId: string;
  challengeId: string;
}

const ChallengeRequestOriginDetails: FC<ChallengeRequestOriginDetailsProps> = ({
  challengeId,
  originDeviceId,
}) => {
  const intl = useIntl();
  const { data, error, loading } = useQuery(GetChallengeOriginDetailsDocument, {
    variables: {
      input: { challengeId, originDeviceId },
    },
  });

  if (error) {
    return <ErrorView />;
  }

  if (loading || !data) {
    <SunshineCard alignItems="center">
      <SunshineCard.Content>
        <OperationDetailsItem
          icon={
            <Squircle backgroundColor="$grey.200" icon="tablet-and-mobile" />
          }
        >
          <Typography.Text>
            <FormattedMessage id="authentication.challenge.origin_device_title" />
          </Typography.Text>
        </OperationDetailsItem>
      </SunshineCard.Content>
    </SunshineCard>;
  }

  const location = intl.formatMessage(
    {
      id: 'authentication.challenge.origin_device_location',
    },
    {
      city: data?.getChallengeOriginDetails.city ?? 'Unknown',
      country: data?.getChallengeOriginDetails.country ?? 'Unknown',
    },
  );
  const device = intl.formatMessage(
    {
      id: 'authentication.challenge.origin_device',
    },
    {
      modelName: data?.getChallengeOriginDetails.modelName ?? 'Unknown',
      name: data?.getChallengeOriginDetails.name ?? 'Unknown',
    },
  );

  return (
    <SunshineCard alignItems="center">
      <SunshineCard.Slot name="aside">
        <Squircle backgroundColor="$grey.200" icon="tablet-and-mobile" />
      </SunshineCard.Slot>

      <SunshineCard.Content width="75%">
        <SunshineCard.Title>
          <FormattedMessage id="authentication.challenge.origin_device_title" />
        </SunshineCard.Title>
        <Typography.Text size="small" variant="secondary">
          <FormattedMessage
            id="authentication.challenge.origin_device_info"
            values={{
              device,
              location,
            }}
          />
        </Typography.Text>
      </SunshineCard.Content>
    </SunshineCard>
  );
};

export default ChallengeRequestOriginDetails;
